import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { postCargarSector } from "../../../../redux/actions/dependenciaEmpleador";
import NuevoSectorForm from "./NuevoSectorForm";

const initialValues = {
  ciiu: null,
  descripcion: "",
  nombre: "",
}

const NuevoSectorFormContainer = ({
  callback,
  open,
  handleClose,
  idDependenciaEmpleador,
}) => {
  const dispatch = useDispatch();
  const [formValues, setFormValues] = useState(initialValues);

  useEffect(() => {
    setFormValues(initialValues);
  }, [open])

  const handleSubmit = (values) => {
    dispatch(postCargarSector({ ...values, idDependenciaEmpleador })).then((v) => {
      if (callback) {
        callback(v);
      }
    })
    handleClose();
  }

  return (
    <NuevoSectorForm
      open={open}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
      initialValues={formValues}
    />
  )

}

export default NuevoSectorFormContainer;